import { steel_span_attr, wood_span_attr, custom_shape_span_attr, selected_attr } from "../graphics/attributes.js";
import * as Graphics from "../graphics/graphics.js"
import { showLengthWithUnits } from 'ws-units'
import Raphael from 'raphael'

let paper = Raphael(
    "model-view",
    document.getElementById("model-view").offsetWidth,
    document.getElementById("model-view").offsetHeight)

var beam_t = 25
var beam_y = 175
var brace_size = 5

let span_attr = steel_span_attr

export function drawBeamModel(project, forPrint) {

    paper.clear()

    const canvasW = forPrint === true ? 800 : Math.min(document.getElementById("model-view").offsetWidth, 900)
    const canvasH = 300

    paper.setSize(canvasW, canvasH)
    
    const beam = project.beam;
    const design = project.design;

    if( beam.nodes.length <= 1 ){
        return;
    }

    //*******************
    // Beam Span
    //*******************
    var totalLength = beam.TotalLength()
    var x_scale = canvasW / (1.15 * totalLength)
    var x_start = 0.075 * totalLength * x_scale
    let span_dom_elements = []

    if(project.isCustom || project.isAluminum) {
        span_attr = custom_shape_span_attr;
    } else if(project.isNorthAmericanSteel || project.isEuropeanSteel || project.isASTMSteel) {
        span_attr = steel_span_attr;
    } else if(project.isWood || project.isEngineeredLumber) {
        span_attr = wood_span_attr;
    }

    let x1 = 0
    let x2 = 0
    for( var i = 0; i < beam.nodes.length-1; i++ ) {
        x1 = x_start + x_scale*beam.nodes[i].x;
        x2 = x_start + x_scale*beam.nodes[i+1].x;
        var dist = beam.nodes[i+1].x-beam.nodes[i].x;
        span_dom_elements.push(Graphics.drawBeamSpan(
            x1, x2, beam_y, beam_y+beam_t, span_attr, i+1, showLengthWithUnits(dist),
            project.shape, paper, i ));
    }

    // draw left and right "add span graphic"
    if(forPrint === false) {
        let left = Graphics.drawAddSpanGraphic(0, x_start - 5, beam_y, beam_y+beam_t, span_attr, project.shape, paper)
        left.node.onclick = () => { document.getElementById('add-left-span-button').click() }
        let right = Graphics.drawAddSpanGraphic(x2 + 5, x2 + x_start, beam_y, beam_y+beam_t, span_attr, project.shape, paper)
        right.node.onclick = () => { document.getElementById('add-right-span-button').click() }
    }

    //now make hover over one dom element select them all...
    for( var i = 0; i < span_dom_elements.length; i++ ) {
        var self = span_dom_elements[i][0];
        self.node.onmouseover = function(){
                this.style.cursor = 'pointer';
                for( var j = 0; j < span_dom_elements.length; j++ ){
                    span_dom_elements[j][0].attr(selected_attr);
                }
            }
        self.node.onmouseout = function(){
                for( var j = 0; j < span_dom_elements.length; j++ ){
                    span_dom_elements[j][0].attr(span_attr);
                    //setSelectableTrigger(self, neighbor, span_attr, selected_attr, "");
                }
            }
        var self2 = span_dom_elements[i][1];
        self2.node.onmouseover = function(){
                this.style.cursor = 'pointer';
                for( var j = 0; j < span_dom_elements.length; j++ ){
                    span_dom_elements[j][0].attr(selected_attr);
                }
            }
        self2.node.onmouseout = function(){
                for( var j = 0; j < span_dom_elements.length; j++ ){
                    span_dom_elements[j][0].attr(span_attr);
                }
            }
    }

    //*******************
    // Supports
    //*******************
    for( var i = 0; i < beam.nodes.length; i++ ) {
        x1 = x_start + x_scale*beam.nodes[i].x;
        var support = beam.nodes[i].support;
        Graphics.drawSupport( support, x1, beam_y+beam_t, beam_t, paper, i);
    }

    //*******************
    // Bracing
    //*******************
    if( design.bracingType === "custom" || design.bracingType === "equal" ) {
        var brace = 0;
        var beamLength = beam.TotalLength();
        for( var i = 0; i < design.customBraces.length; i++ ) {
            brace = design.customBraces[i].x;
            if( brace <= beamLength ) {
                brace *= x_scale;
                brace += x_start;
                Graphics.drawBrace( brace, beam_y, brace_size, paper );
                Graphics.drawBrace( brace, beam_y+beam_t, brace_size, paper );
            }
        }
    }

    //*******************
    // Distributed Loads
    //*******************
    //arrange distributed loads
    var load_y = []
    for(var i = 0; i < beam.distLoads.length; i++) {
        var y = beam_y;
        for(var j = 0; j < i; j++) {
            if(beam.distLoads[j].Overlaps(beam.distLoads[i])) y -= Graphics.dist_load_arrow_shaft;
        }
        load_y.push(y);
    }

    var labels = [];
    // now draw them so that labels don't get covered up
    // sort loads from longest to shortest
    function distLoadSort(a, b){ return b.Length() - a.Length() }
    const distLoads = beam.distLoads
    distLoads.sort(distLoadSort)
    
    for( var i = distLoads.length-1; i >= 0; i-- ) {
        x1 = x_start + x_scale * beam.distLoads[i].x1;
        x2 = x_start + x_scale * beam.distLoads[i].x2;
        var l = beam.distLoads[i].Label(" k/ft");
        for( var j = 0; j < i; j++ ) {
            if( beam.distLoads[j].Overlaps(
                beam.distLoads[i])) y -= Graphics.dist_load_arrow_shaft;
        }
        var y = beam_y;
        if(load_y[i]) y = load_y[i];
        if(beam.distLoads[i].isLinear){
            let q = beam.distLoads[i].firstNonZeroLinearLoadValues()
            if(typeof q !== 'undefined') {
                labels.push(
                    Graphics.drawLinearLoad(q[0], q[1], x1, x2, y, y, l, paper, i));
            }
        }else{
            labels.push(
                Graphics.drawDistributedLoad(beam.distLoads[i].direction(), x1, x2, y, l, paper, i));
        }
    }
    //*******************
    // Point Loads
    //*******************
    for(var i = 0; i < beam.pointLoads.length; i++) {
        x1 = x_start + x_scale * beam.pointLoads[i].x;
        var l = beam.pointLoads[i].createLabel();
        if( beam.pointLoads[i].isMoment ) {
            labels.push(Graphics.drawMomentLoad(x1, beam_y, beam_t, l, paper, i));
        } else {
            labels.push(Graphics.drawPointLoad(x1, beam_y, l, paper, i));
        }
    }

    labels = labels.flat()
    for(var i = 0; i < labels.length; i++) {
        labels[i].toFront();
    }
    
    //*******************
    // Cross section
    //*******************
    setCrossSectionBeamRotationButton(project)
    const rotation = project.shapeCanBeRotated ? beam.crossSectionRotation : 0
    Graphics.drawCrossSection(project, rotation, span_attr, paper);

}

function setCrossSectionBeamRotationButton(project) {
    if(project.beam.crossSectionRotation === 0) {
        document.getElementById("beam-rotation-0-degrees-button").checked = true
        document.getElementById("beam-rotation-90-degrees-button").checked = false
    } else {
        document.getElementById("beam-rotation-0-degrees-button").checked = false
        document.getElementById("beam-rotation-90-degrees-button").checked = true
    }
}